import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-secondary)',
      borderTop: '1px solid var(--border-light)',
      paddingTop: '80px',
      paddingBottom: '40px'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '60px'
        }}>
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_7f41c477-c015-4f39-8756-185b98cacc33/artifacts/abkoigru_Care%20Logo%201200x1200%20Pixel.png" 
              alt="Care Pharmacy" 
              style={{ height: '55px', width: 'auto', marginBottom: '24px' }}
            />
            <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
              Caring health & wealth — delivering quality medicines, reliable guidance and everyday savings across 190+ stores.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="https://www.facebook.com/share/1GE4bJyfsa/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s ease' }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--brand-blue)'} onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/brijeshpatel_pharmaretailchain?igsh=N2FsZ3V2NTY5ZjBj&utm_source=qr" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s ease' }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--brand-blue)'} onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                <Instagram size={20} />
              </a>
              <a href="https://www.linkedin.com/in/brijeshpharmacist?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s ease' }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--brand-blue)'} onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                <Linkedin size={20} />
              </a>
              <a href="https://youtube.com/@brijeshpatel_pharmaretail?si=mDMfwR1mHsxbreKl" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s ease' }} onMouseOver={(e) => e.currentTarget.style.color = 'var(--brand-blue)'} onMouseOut={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}>
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '24px' }}>Quick Links</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li><Link to="/about" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>About Us</Link></li>
              <li><Link to="/services" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Services</Link></li>
              <li><Link to="/franchise" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Franchise</Link></li>
              <li><Link to="/stores" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Store Locator</Link></li>
              <li><Link to="/career" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Careers</Link></li>
            </ul>
          </div>

          {/* Group Companies */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '24px' }}>Group Companies</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>One Deal Life Science</li>
              <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>Quickint Solution (Pickora)</li>
              <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>Harikrishna Medical</li>
              <li>
                <a href="https://www.curepath.co" target="_blank" rel="noopener noreferrer" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  CurePath International
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '24px' }}>Contact Us</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <li style={{ display: 'flex', gap: '12px' }}>
                <MapPin size={18} style={{ color: 'var(--text-secondary)', flexShrink: 0, marginTop: '2px' }} />
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  Wall Street-2, Opp. Orient Club, Gujarat College Road, Ahmedabad-380006
                </span>
              </li>
              <li style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Phone size={18} style={{ color: 'var(--text-secondary)' }} />
                <a href="tel:+916358585323" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  +91-6358585323
                </a>
              </li>
              <li style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Mail size={18} style={{ color: 'var(--text-secondary)' }} />
                <a href="mailto:info@carepharmacy.co" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  info@carepharmacy.co
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p className="body-small" style={{ color: 'var(--text-secondary)', margin: 0 }}>
            © 2024 Care Pharmacy Pvt. Ltd. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <Link to="/privacy" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
              Privacy Policy
            </Link>
            <Link to="/terms" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
              Terms & Conditions
            </Link>
            <Link to="/refund" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;